import {
    ActionNomenclatureType,
    ERROR_NOMENCLATURE_CHANGE,
    ERROR_NOMENCLATURE_CREATE,
    ERROR_NOMENCLATURE_DELETE,
    ERROR_NOMENCLATURE_DETAIL,
    ERROR_NOMENCLATURE_LIST,
    FILL_NOMENCLATURE_CHANGE,
    FILL_NOMENCLATURE_CREATE,
    FILL_NOMENCLATURE_DELETE,
    FILL_NOMENCLATURE_DETAIL,
    FILL_NOMENCLATURE_LIST,
    InitialState,
    START_NOMENCLATURE_CHANGE,
    START_NOMENCLATURE_CREATE,
    START_NOMENCLATURE_DELETE,
    START_NOMENCLATURE_DETAIL,
    START_NOMENCLATURE_LIST, 
    STOP_NOMENCLATURE_CHANGE, 
    STOP_NOMENCLATURE_CREATE, 
    STOP_NOMENCLATURE_DELETE, 
    STOP_NOMENCLATURE_DETAIL, 
    STOP_NOMENCLATURE_LIST
} from "./types";

const initialState: InitialState = {
    nomenclatureList: {
        data: [],
        loading: false,
        error: null,
    },
    nomenclatureListDetail: {
        data: null,
        loading: false,
        error: null,
    },
    nomenclatureListCreate: {
        loading: false,
        error: null,
        data: false
    },
    nomenclatureListEdit: {
        loading: false,
        error: null
    },
    nomenclatureListDelete: {
        data: false,
        loading: false,
        error: null
    },
}


export const nomenclatureReducer = (state = initialState, action: ActionNomenclatureType): InitialState => {
    switch (action.type) {

        //ПОЛУЧЕНИЕ СПИСКА
        case START_NOMENCLATURE_LIST:
            return {
                ...state,
                nomenclatureList: {
                    ...state.nomenclatureList,
                    loading: true,
                    error: null
                }
            }
        case STOP_NOMENCLATURE_LIST:
            return {
                ...state,
                nomenclatureList: {
                    ...state.nomenclatureList,
                    loading: false
                }
            }
        case FILL_NOMENCLATURE_LIST:
            return {
                ...state,
                nomenclatureList: {
                    ...state.nomenclatureList,
                    data: action.payload
                }
            }
        case ERROR_NOMENCLATURE_LIST:
            return {
                ...state,
                nomenclatureList: {
                    ...state.nomenclatureList,
                    error: action.payload
                }
            }




        //РЕДАКТИРОВАНИЕ
        case START_NOMENCLATURE_CHANGE:
            return {
                ...state,
                nomenclatureListEdit: {
                    ...state.nomenclatureListEdit,
                    loading: true,
                    error: null
                }
            }
        case STOP_NOMENCLATURE_CHANGE:
            return {
                ...state,
                nomenclatureListEdit: {
                    ...state.nomenclatureListEdit,
                    loading: false
                }
            }
        case FILL_NOMENCLATURE_CHANGE:
            return {
                ...state,
                nomenclatureListEdit: {
                    ...state.nomenclatureListEdit,
                }
            }
        case ERROR_NOMENCLATURE_CHANGE:
            return {
                ...state,
                nomenclatureListEdit: {
                    ...state.nomenclatureListEdit,
                    error: action.payload
                }
            }




        //ПОЛУЧЕНИЕ ДЕТАЛЕЙ
        case START_NOMENCLATURE_DETAIL:
            return {
                ...state,
                nomenclatureListDetail: {
                    ...state.nomenclatureListDetail,
                    loading: true,
                    error: null
                }
            }
        case STOP_NOMENCLATURE_DETAIL:
            return {
                ...state,
                nomenclatureListDetail: {
                    ...state.nomenclatureListDetail,
                    loading: false
                }
            }
        case FILL_NOMENCLATURE_DETAIL:
            return {
                ...state,
                nomenclatureListDetail: {
                    ...state.nomenclatureListDetail,
                }
            }
        case ERROR_NOMENCLATURE_DETAIL:
            return {
                ...state,
                nomenclatureListDetail: {
                    ...state.nomenclatureListDetail,
                    error: action.payload
                }
            }




        //УДАЛЕНИЕ
        case START_NOMENCLATURE_DELETE:
            return {
                ...state,
                nomenclatureListDelete: {
                    ...state.nomenclatureListDelete,
                    loading: true,
                    error: null,
                }
            }
        case STOP_NOMENCLATURE_DELETE:
            return {
                ...state,
                nomenclatureListDelete: {
                    ...state.nomenclatureListDelete,
                    loading: false,
                    data: false
                }
            }
        case FILL_NOMENCLATURE_DELETE:
            return {
                ...state,
                nomenclatureListDelete: {
                    ...state.nomenclatureListDelete,
                    data: true
                }
            }
        case ERROR_NOMENCLATURE_DELETE:
            return {
                ...state,
                nomenclatureListDelete: {
                    ...state.nomenclatureListDelete,
                    error: action.payload
                }
            }





        //СОЗДАНИЕ
        case START_NOMENCLATURE_CREATE:
            return {
                ...state,
                nomenclatureListCreate: {
                    ...state.nomenclatureListCreate,
                    loading: true,
                    error: null
                }
            }
        case STOP_NOMENCLATURE_CREATE:
            return {
                ...state,
                nomenclatureListCreate: {
                    ...state.nomenclatureListCreate,
                    loading: false,
                    data: false
                }
            }
        case FILL_NOMENCLATURE_CREATE:
            return {
                ...state,
                nomenclatureListCreate: {
                    ...state.nomenclatureListCreate,
                    data: true
                }
            }
        case ERROR_NOMENCLATURE_CREATE:
            return {
                ...state,
                nomenclatureListCreate: {
                    ...state.nomenclatureListCreate,
                    error: action.payload
                }
            }





        default:
            return state
    }
}